import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import "./Pagination.css";

function PaginatedItems({ total, page, setPagination, itemsPerPage }) {
	const [pageCount, setPageCount] = useState(itemsPerPage);
	
	useEffect(() => {
		setPageCount(Math.ceil(total / itemsPerPage));
	}, [itemsPerPage, total]);

	const handlePageClick = (event) => {	
		window.scrollTo(0, 100);
		console.log(`User requested page number ${event.selected}`);
		setPagination((state) => {
			return { ...state, page: event.selected + 1 };
		});
	};

	return (
		<>
			<ReactPaginate
				nextLabel={
					<span data-cy="pagination-next">
						<ArrowForwardIosIcon size={"20px"} className="cursor-pointer" />
					</span>
				}
				onPageChange={handlePageClick}
				pageRangeDisplayed={3}
				marginPagesDisplayed={2}
				pageCount={pageCount}
				previousLabel={
					<span data-cy="pagination-prev">
						<ArrowBackIosIcon size={"10px"} className="cursor-pointer" />
					</span>
				}
				pageClassName="page-item"
				pageLinkClassName="page-link"
				previousClassName="prev-item"
				previousLinkClassName="page-link"
				nextClassName="next-item"
				nextLinkClassName="page-link"
				breakLabel="..."
				breakClassName="page-item"
				breakLinkClassName="page-link"
				containerClassName="pagination"
				activeClassName="active"
				forcePage={page}
				renderOnZeroPageCount={null}
			/>
		</>
	);
}

export default PaginatedItems;